export function hoverOnHorizontalScroll() {

    return {

        restrict: 'A',
        link: function ($scope, $element, attrs, ...etc) {

            angular.element(document).ready(() => {

                let element = $element[0];

                let scrollable = document.getElementById(attrs.toHoverOn);

                let limiter = element.parentElement;

                element.style['position'] = 'relative';

                element.style['width'] = scrollable.offsetWidth - scrollable.offsetWidth*0.05 + "px";

//                let offsetLimit = 1500 - 800;

                scrollable.addEventListener('scroll', (e) => {

                    let offsetLimit = limiter.offsetWidth - element.offsetWidth;

                    if(scrollable.scrollLeft < offsetLimit){

                        element.style['left'] = scrollable.scrollLeft + 'px';

                    }

                });

                window.addEventListener('resize', () => {

                    element.style['width'] = scrollable.offsetWidth - scrollable.offsetWidth*0.05 + "px";
                });

            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/ui/directives/hover-on-horizontal-scroll.directive.js